// src/pages/Unauthorized.jsx
import React from "react";

export default function Unauthorized() {
  return <h1>❌ لا تملك الصلاحيات للدخول</h1>;
}
